import * as lang_E from './Lang_E.json';
import * as lang_B from './Lang_B.json';
import * as lang_A from './Lang_A.json';
import * as lang_U from './Lang_U.json';

let Lang_E = lang_E;
let Lang_B = lang_B;
let Lang_A = lang_A;
let Lang_U = lang_U;

export const english = {
    lang: "en",
    data: {
        COMMON: {
            WELCOME: Lang_E.COMMON.WELCOME,
            VP_MES_TEXT: Lang_E.COMMON.VP_MES_TEXT,
            VP_MES_MAIN_01: Lang_E.COMMON.VP_MES_MAIN_01,
            VP_MES_MAIN_02: Lang_E.COMMON.VP_MES_MAIN_02,
            VP_MES_MAIN_03: Lang_E.COMMON.VP_MES_MAIN_03,
            P_MES_TEXT: Lang_E.COMMON.P_MES_TEXT,
            P_MES_MAIN_01: Lang_E.COMMON.P_MES_MAIN_01,
            P_MES_MAIN_02: Lang_E.COMMON.P_MES_MAIN_02,
            P_MES_MAIN_03: Lang_E.COMMON.P_MES_MAIN_03,
            P_MES_MAIN_04: Lang_E.COMMON.P_MES_MAIN_04,
            P_MES_MAIN_05: Lang_E.COMMON.P_MES_MAIN_05,
            P_MES_MAIN_06: Lang_E.COMMON.P_MES_MAIN_06,
            C_MES_TEXT: Lang_E.COMMON.C_MES_TEXT,
            C_MES_MAIN_01: Lang_E.COMMON.C_MES_MAIN_01,
            HISTORY_BODY_1: Lang_E.COMMON.HISTORY_BODY_1,
            HISTORY_BODY_2: Lang_E.COMMON.HISTORY_BODY_2,
            MISSION_BODY_1: Lang_E.COMMON.MISSION_BODY_1,
            MISSION_BODY_2: Lang_E.COMMON.MISSION_BODY_2,
        }

    }
};

export const bangla = {
    lang: "bn",
    data: {
        COMMON: {
            WELCOME: Lang_B.COMMON.WELCOME,
            VP_MES_TEXT: Lang_B.COMMON.VP_MES_TEXT,
            VP_MES_MAIN_01: Lang_B.COMMON.VP_MES_MAIN_01,
            VP_MES_MAIN_02: Lang_B.COMMON.VP_MES_MAIN_02,
            VP_MES_MAIN_03: Lang_B.COMMON.VP_MES_MAIN_03,
            P_MES_TEXT: Lang_B.COMMON.P_MES_TEXT,
            P_MES_MAIN_01: Lang_B.COMMON.P_MES_MAIN_01,
            P_MES_MAIN_02: Lang_B.COMMON.P_MES_MAIN_02,
            P_MES_MAIN_03: Lang_B.COMMON.P_MES_MAIN_03,
            P_MES_MAIN_04: Lang_B.COMMON.P_MES_MAIN_04,
            P_MES_MAIN_05: Lang_B.COMMON.P_MES_MAIN_05,
            P_MES_MAIN_06: Lang_B.COMMON.P_MES_MAIN_06,
            C_MES_TEXT: Lang_B.COMMON.C_MES_TEXT,
            C_MES_MAIN_01: Lang_B.COMMON.C_MES_MAIN_01,
            HISTORY_BODY_1: Lang_B.COMMON.HISTORY_BODY_1,
            HISTORY_BODY_2: Lang_B.COMMON.HISTORY_BODY_2,
            MISSION_BODY_1: Lang_B.COMMON.MISSION_BODY_1,
            MISSION_BODY_2: Lang_B.COMMON.MISSION_BODY_2,
        }
    }

};

export const arabic = {
    lang: "ar",
    data: {
        COMMON: {
            WELCOME: Lang_A.COMMON.WELCOME,
            VP_MES_TEXT: Lang_A.COMMON.VP_MES_TEXT,
            VP_MES_MAIN_01: Lang_A.COMMON.VP_MES_MAIN_01,
            VP_MES_MAIN_02: Lang_A.COMMON.VP_MES_MAIN_02,
            VP_MES_MAIN_03: Lang_A.COMMON.VP_MES_MAIN_03,
            P_MES_TEXT: Lang_A.COMMON.P_MES_TEXT,
            P_MES_MAIN_01: Lang_A.COMMON.P_MES_MAIN_01,
            P_MES_MAIN_02: Lang_A.COMMON.P_MES_MAIN_02,
            P_MES_MAIN_03: Lang_A.COMMON.P_MES_MAIN_03,
            P_MES_MAIN_04: Lang_A.COMMON.P_MES_MAIN_04,
            P_MES_MAIN_05: Lang_A.COMMON.P_MES_MAIN_05,
            P_MES_MAIN_06: Lang_A.COMMON.P_MES_MAIN_06,
            C_MES_TEXT: Lang_A.COMMON.C_MES_TEXT,
            C_MES_MAIN_01: Lang_A.COMMON.C_MES_MAIN_01,
            HISTORY_BODY_1: Lang_A.COMMON.HISTORY_BODY_1,
            HISTORY_BODY_2: Lang_A.COMMON.HISTORY_BODY_2,
            MISSION_BODY_1: Lang_A.COMMON.MISSION_BODY_1,
            MISSION_BODY_2: Lang_A.COMMON.MISSION_BODY_2,
        }
    }

};


export const urdu = {
    lang: "ur",
    data: {
        COMMON: {
            WELCOME: Lang_U.COMMON.WELCOME,
            VP_MES_TEXT: Lang_U.COMMON.VP_MES_TEXT,
            VP_MES_MAIN_01: Lang_U.COMMON.VP_MES_MAIN_01,
            VP_MES_MAIN_02: Lang_U.COMMON.VP_MES_MAIN_02,
            VP_MES_MAIN_03: Lang_U.COMMON.VP_MES_MAIN_03,
            P_MES_TEXT: Lang_U.COMMON.P_MES_TEXT,
            P_MES_MAIN_01: Lang_U.COMMON.P_MES_MAIN_01,
            P_MES_MAIN_02: Lang_U.COMMON.P_MES_MAIN_02,
            P_MES_MAIN_03: Lang_U.COMMON.P_MES_MAIN_03,
            P_MES_MAIN_04: Lang_U.COMMON.P_MES_MAIN_04,
            P_MES_MAIN_05: Lang_U.COMMON.P_MES_MAIN_05,
            P_MES_MAIN_06: Lang_U.COMMON.P_MES_MAIN_06,
            C_MES_TEXT: Lang_U.COMMON.C_MES_TEXT,
            C_MES_MAIN_01: Lang_U.COMMON.C_MES_MAIN_01,
            HISTORY_BODY_1: Lang_U.COMMON.HISTORY_BODY_1,
            HISTORY_BODY_2: Lang_U.COMMON.HISTORY_BODY_2,
            MISSION_BODY_1: Lang_U.COMMON.MISSION_BODY_1,
            MISSION_BODY_2: Lang_U.COMMON.MISSION_BODY_2,
        }
    }

};

